import { initDialog, openDialog } from '../components/common/dialog';
import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
import {
  updateSlideAccessibility,
  setSwiperButtonAriaLabels,
  updateNavigationAccessibility,
} from '../components/common/carousel';

document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');
  const headerHeight = header ? header.offsetHeight : 0;

  const scrollToSection = (triggerSelector, targetId) => {
    const triggers = document.querySelectorAll(triggerSelector);
    if (!triggers.length) return;
    triggers.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        const targetEl = document.getElementById(targetId);
        if (!targetEl) return;
        const posY = targetEl.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: posY - headerHeight,
          behavior: 'smooth',
        });
      });
    });
  };

  scrollToSection('.work-scroll', 'job-offers');
  scrollToSection('#benefit-scroll', 'benefits');

  const workersContainer = document.querySelector('.workers-swiper');
  if (workersContainer) {
    new Swiper(workersContainer, {
      modules: [Navigation, A11y],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.workers-next',
        prevEl: '.workers-prev',
      },
      on: {
        init() {
          updateSlideAccessibility(this);
          updateNavigationAccessibility(this);
          setSwiperButtonAriaLabels(this.el);
        },
        slideChange() {
          updateSlideAccessibility(this);
          updateNavigationAccessibility(this);
        },
        resize() {
          updateNavigationAccessibility(this);
        },
      },
    });
  }

  const workContainer = document.querySelector('.work-swiper');
  if (workContainer) {
    new Swiper(workContainer, {
      modules: [Navigation, A11y],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.work-next',
        prevEl: '.work-prev',
      },
      breakpoints: {
        699: { slidesPerView: 2 },
        991: { slidesPerView: 3 },
        1439: { slidesPerView: 5 },
      },
      on: {
        init() {
          updateSlideAccessibility(this);
          updateNavigationAccessibility(this);
          setSwiperButtonAriaLabels(this.el);
        },
        slideChange() {
          updateSlideAccessibility(this);
          updateNavigationAccessibility(this);
        },
        resize() {
          updateNavigationAccessibility(this);
        },
      },
    });

    const images = workContainer.querySelectorAll('.box-single img');
    const slides = workContainer.querySelectorAll('.swiper-slide');
    const dialog = initDialog('image-dialog');
    let modalSwiper = null;

    workContainer.addEventListener('click', e => {
      const img = e.target.closest('.box-single img');
      if (!img) return;
      const index = Array.from(images).indexOf(img);
      openImageModal(index);
      openDialog(dialog);
    });

    slides.forEach((slide, index) => {
      slide.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openImageModal(index);
          openDialog(dialog);
        }
      });
    });

    function openImageModal(initialIndex) {
      const modalWrapper = document.querySelector('#image-dialog .modal-swiper .swiper-wrapper');
      if (!modalWrapper) return;

      modalWrapper.innerHTML = '';

      const fragment = document.createDocumentFragment();
      images.forEach(origImg => {
        const slide = document.createElement('div');
        slide.classList.add('swiper-slide');
        const imageEl = document.createElement('img');
        imageEl.src = origImg.dataset.src;
        slide.appendChild(imageEl);
        fragment.appendChild(slide);
      });
      modalWrapper.appendChild(fragment);

      if (modalSwiper) {
        modalSwiper.destroy(true, true);
      }
      modalSwiper = new Swiper('.modal-swiper', {
        modules: [Navigation, A11y],
        initialSlide: initialIndex,
        slidesPerView: 1,
        navigation: {
          nextEl: '.modal-next',
          prevEl: '.modal-prev',
        },
      });
    }
  }
});
